import { useSelector } from "react-redux";

export function useStudentInvites() {
  return useSelector((state) => state.studentInvites);
}
